<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition" :overlay=false>
      <v-badge bottom :overlap="true" title="Comments"
               class="cursor-pointer small-badge2 ml-5"
               slot="activator"
               @click="activate"
               color="grey">
        <span slot="badge">{{item.comments}}</span>
        <v-icon class="" medium>comment</v-icon>
      </v-badge>
        <v-card class="grey pt-5">
             <v-toolbar fixed>
               <v-toolbar-title class="flex xs12">
                 <v-flex class=" offset-md2 md8">{{item.headline}}</v-flex>
               </v-toolbar-title>
               <v-spacer></v-spacer>
               <v-toolbar-items>
                 <v-btn icon @click.native="dialog = false" title="close">
                   <v-icon>close</v-icon>
                 </v-btn>
               </v-toolbar-items>
             </v-toolbar>
             <v-layout row wrap mt-5>
               <v-flex xs12 md8 offset-md2 mt-4 mb-4>
                 <v-card>
                   <v-card-text>
                     <v-flex xs12 text-xs-center>
                       <img v-if="item.path !== '.'" class="responsive-img text-xs-center white" :src="$helper.getLocation()+item.path">
                     </v-flex>
                     <v-flex xs12>
                       <v-layout row wrap>
                         <v-badge bottom :overlap="true" :title="activeUser.id ? 'Like' : 'Please login on the top right to like this item.'"
                                  class="ml-4 small-badge" :class="activeUser.id ? 'cursor-pointer highlight' : ''"
                                  @click.native="activeUser.id ? like({item,val:'like', user_id: activeUser.id}) : ''">
                           <span slot="badge" class="small">{{item.likes.split(',').length -1}}</span>
                           <v-icon class="text-elevation-5" medium
                                   :color="item.likes.indexOf(activeUser.id)>-1 ? 'blue darken-3' : 'blue lighten-3'">thumb_up
                           </v-icon>
                         </v-badge>
                         <v-badge bottom :overlap="true" :title="activeUser.id ? 'Mark as favorite' : 'Please login on the top right to like this item.'" class="small-badge" :class="activeUser.id ? 'cursor-pointer highlight' : ''"
                                  @click.native="activeUser.id ? like({item,val:'favorite', user_id: activeUser.id}) : ''">
                           <span slot="badge">{{item.likes_favorite.split(',').length -1}}</span>
                           <v-icon class="text-elevation-5" medium
                                   :color="item.likes_favorite.indexOf(activeUser.id)>-1 ? 'red darken-3' : 'red lighten-3'">favorite
                           </v-icon>
                         </v-badge>
                       </v-layout>
                     </v-flex>
                     <v-flex xs12 px-5 py-3 class="word-break">
                       {{item.long_text}}
                     </v-flex>
                   </v-card-text>
                 </v-card>
               </v-flex>
               <v-flex xs12 md8 offset-md2 mb-5>
                 <v-card v-for="(comment,key) in comments" :key="key" class="mt-2 elevation-3">
                   <v-card-title class="pr-5 py-3 grey lighten-1 elevation-inset-2">
                     <v-icon class="mr-4" medium>comment</v-icon>
                     <h3>{{comment.headline}}</h3>
                   </v-card-title>
                   <v-card-text class="px-5 py-3">
                     {{comment.text}}
                   </v-card-text>
                 </v-card>


               </v-flex>
             </v-layout>
           </v-card>
         </v-dialog>
       </v-layout>
     </template>
     <script>
       // eslint-disable-next-line import/extensions
       import {mapGetters, mapActions} from 'vuex';
       import ConfirmModal from '../general/Modal/ConfirmModal';

       export default{
         components: {
           ConfirmModal
         },
         name: 'comments',
         props: ['item'],
         computed: {
           ...mapGetters(['userById', 'activeUser']),
         },
         data () {
           return {
             dialog: false,
             search: '',
             deleteSuccess: false,
             notifications: false,
             sound: true,
             widgets: false,
             comments: [],
             headers: [
               {text: 'User ', align: 'left', value: 'user_id'},
               {text: 'Headline', align: 'left', value: 'headline'},
               {text: 'Text', align: 'left', value: 'text'},
               {text: 'Likes:', align: 'left', value: 'likes'},
               {text: 'Created at:', align: 'left', value: 'created_at'},
               {text: 'Updated at:', align: 'left', value: 'updated_at'},
             ],
           };
         },
         methods: {
           ...mapActions(['likeNews', 'updatePoints']),
           deleteComment(id) {
             this.$http.delete(this.$helper.apiUrl()+'/content/news_comments/' + id).then(resp => {
               this.getComments();
             });
           },
           activate(){

            this.getComments();
            this.dialog = true;
             // console.log(this.comments)
           },
           getComments() {
             this.$http.get(this.$helper.apiUrl()+'/content/news/' + this.item.id + '/comments').then(resp => {
               // console.log(resp.body);
               this.comments = resp.body;
             });
           },
           fullName (user) {
             return user.userName + ': ' + user.firstName + ' ' + user.lastName;
           },
           like({item, val, user_id}) {
             this.toggleLike = true;
             this.likeNews({item, val, user_id,  cb: this.updatePoints});
           },
         },
         mounted() {
           // console.log('getComments')
         },
       };
     </script>
